import * as React from 'react';
import { TStockCreateBody, TStockTypeEnum } from 'api/stock/stock.types';

export type TStockFormValues = Omit<TStockCreateBody, 'variation'> & {
  variation: string;
};

type TStockFormProps = {
  onSubmit: (data: TStockFormValues) => void;
  isLoading?: boolean;
};

export type TStockForm = React.FC<TStockFormProps>;

export const STOCK_TYPE_OPTIONS: Array<{ id: TStockTypeEnum; label: string }> =
  [
    { id: TStockTypeEnum.PhoneCase, label: 'Phone case' },
    { id: TStockTypeEnum.Cup, label: 'Cup' },
  ];
